import { Observable } from 'rxjs';
import { $httpClient } from '@/services/httpClient';
import { DOWNLOAD_INSURERS_REPORTS, GET_INSURERS_REPORTS } from '@/types/insurers-reports.types';
import { Grid } from '@/models/Grid.model';

export default class InsurersReportsService {
  private readonly baseApi: string;
  private readonly insurersApi: string;

  constructor() {
    this.baseApi = 'api/bo/';
    this.insurersApi = 'mivtachim/';
  }

  public getInsurersReports(searchObject): Observable<any> {
    return $httpClient.post<Grid>(this.baseApi + this.insurersApi + GET_INSURERS_REPORTS, searchObject);
  }

  public downloadReport(reportId): Observable<any> {
    return $httpClient.get(this.baseApi + this.insurersApi + DOWNLOAD_INSURERS_REPORTS + '?key=' + reportId);
  }
}
